import portail1 from'./Images/pexels-andrea-piacquadio-3771839.jpg'
export  const Phase3Data =[
    {
        id:1,
        image:portail1,
                },
    
]